import { colors, measure } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";

const styles = stylex.create({
	base: {
		alignItems: "center",
		blockSize: "56px",
		display: "grid",
		flexShrink: 0,
		gap: measure.spacingGapMin,
		gridTemplateColumns: "auto 1fr auto",
		paddingInline: measure.spacingHorizontalSmaller,
		backgroundColor: colors.neutralBgDefault,
	},
	center: {
		minWidth: 0,
	},
});

type TopBarDefaultProps = {
	slotStart?: ReactNode;
	slotCenter?: ReactNode;
	slotEnd?: ReactNode;
};

export const Default = ({ slotStart, slotCenter, slotEnd }: TopBarDefaultProps) => {
	return (
		<header {...stylex.props(styles.base)}>
			<div>{slotStart}</div>
			<div {...stylex.props(styles.center)}>{slotCenter}</div>
			<div>{slotEnd}</div>
		</header>
	);
};
